import { Module } from "vuex";
import { StoreState } from "@/store/type";
import state, { IGroupsState } from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const GroupsModule: Module<IGroupsState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default GroupsModule;
